import {LocaleItem} from "@core/shared/models/translation";

export const allowedLocales: string[] = ['fr', 'en'];

export const restrictLocales = (localeItems: LocaleItem[]): LocaleItem[] => {

    const allowedLocale: string[] = allowedLocales;

    return localeItems.filter((localItem: LocaleItem): boolean => {

        return allowedLocale.includes(localItem.id);
    });
};
